import React, { useRef, useState } from "react"
import { Row, Col, Input, Form, Button, Spin, message } from "antd"
import styled from "styled-components"
import { Link } from "gatsby"
import Logo from "../../../images/logo-black.png"
import Send from "../../../images/send.svg"
import useFooter from "../../../utils/useFooter"
import axios from "axios"

const StyledSection = styled.div`
  padding-left: 3rem;
  padding-top: 3rem;
  padding-bottom: 3rem;
  padding-right: 3rem;

  h1 {
    font-size: 22px;
    line-height: 40px;
    color: #172315;
    font-weight: 700;
  }
  .logo {
    filter: grayscale(100%) brightness(0%) contrast(100%);
    width: 200px;
  }
  .nav-area {
    list-style: none;
    padding: 0;
    margin: 0;
    padding-left: 1rem;
    & li {
      line-height: 18px;
      & a {
        text-decoration: none;
        font-size: 16px;
        line-height: 40px;
        color: #172315;
        font-weight: 500;
        :hover {
          color: #000;
          text-decoration: underline;
        }
      }
    }
  }

  ${({ theme: { down, breakpoints } }) => down(breakpoints.md)} {
    padding-left: 1rem;
    padding-right: 1rem;
    .nav-area {
      padding-left: 8px;
      & li {
        line-height: 18px;
        & a {
          font-size: 14px;
          line-height: 40px;
        }
      }
    }
  }
`

const Footer = () => {
  const [loading, setloading] = useState(false)
  const { footerMenu } = useFooter()

  const myRef = useRef(null)

  const onSubscribe = async values => {
    setloading(true)
    const formData = new FormData()
    formData.append("email", values.email)
    const url = `${process.env.GATSBY_API_URL}/wp-json/contact-form-7/v1/contact-forms/309/feedback`
    axios
      .post(url, formData)
      .then(({ data }) => {
        console.log(data)
        message.success(data.message)
        setloading(false)
      })
      .catch(error => {
        console.log(error)
        setloading(false)
      })
  }

  return (
    <StyledSection>
      <Row gutter={6}>
        <Col xs={24} sm={24} md={5}>
          <img alt="logo" src={Logo} className="logo" />
        </Col>
        <Col xs={24} sm={24} md={4}>
          <ul className="nav-area">
            {footerMenu.slice(0, 4).map(item => (
              <li key={item.ID}>
                <Link to={item.slug === "home" ? "/" : `/${item.slug}`}>
                  <a>{item.title}</a>
                </Link>
              </li>
            ))}
          </ul>
        </Col>
        <Col xs={24} sm={24} md={4}>
          <ul className="nav-area">
            {footerMenu.slice(4, 7).map(item => (
              <li key={item.ID}>
                {/* <Link to={item.slug}> */}
                <a>{item.title}</a>
                {/* </Link> */}
              </li>
            ))}
          </ul>
        </Col>
        <Col xs={24} sm={24} md={4}>
          <ul className="nav-area">
            {footerMenu.slice(7).map(item => (
              <li key={item.ID}>
                <Link to={`/${item.slug}`}>
                  <a>
                    {item.slug === "term-condition"
                      ? item.title.replace("#038;", "")
                      : item.title}
                  </a>
                </Link>
              </li>
            ))}
          </ul>
        </Col>
        <Col xs={24} sm={24} md={7}>
          <h1>Subscribe Newsletter</h1>
          {loading ? (
            <Row style={{ marginTop: "2rem" }} justify="center" align="middle">
              <Spin />
            </Row>
          ) : (
            <Form onFinish={onSubscribe}>
              <Form.Item
                name="email"
                rules={[
                  {
                    type: "email",
                    message: "The input is not valid E-mail!",
                  },
                  {
                    required: true,
                    message: "Please input your E-mail!",
                  },
                ]}
              >
                <Input
                  placeholder="Email Address"
                  suffix={
                    <img
                      alt="send"
                      src={Send}
                      onClick={() => myRef.current.click()}
                    />
                  }
                />
              </Form.Item>
              <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button
                  ref={myRef}
                  style={{ opacity: 0 }}
                  type="primary"
                  htmlType="submit"
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          )}
        </Col>
      </Row>
    </StyledSection>
  )
}

export default Footer
